const urlRegex = /https?:\/\/([\p{L}\p{N}\p{Emoji}\-_]+\.)+[\p{L}\p{N}\p{Emoji}-]+[^\p{Z}\s]*([^\p{Z}\p{P}]|\/|)/gu;

function extractLinks(text) {
  const source = (text || '').toString();
  const urlArray = [];
  let matchArray;

  // Iterate through any URLs in the text.
  // eslint-disable-next-line no-cond-assign
  while ((matchArray = urlRegex.exec(source)) !== null) {
    const token = matchArray[0];
    if (token.length >= 13) { // e.g. http://cn.co
      urlArray.push(token.trim());
    }
  }

  const url = urlArray[0];
  // remove last ')' if no '('
  if (url && (url.lastIndexOf(')') == (url.length - 1) && (url.indexOf('(') == -1))) {
    urlArray[0] = url.substr(0, url.length - 1);
  }

  return urlArray;
}

function isValidUrl(textval) {
  return urlRegex.test(textval);
}

function extractIncompleteLinks(text) {
  // find links wo www and http.

  const srg = /(^|[\s])([a-zA-Z0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF.]+\.(?:co\.uk|com|cc|net|ru|org)[^,\s]*)/ig;
  if (!text) {
    return [];
  }
  return text.match(srg) || [];
}

export default {
  extractLinks,
  extractIncompleteLinks,
  isValidUrl,
};
